<template>
    <div class='page'>
        <!-- 搜索 -->
        <el-form v-if='isSearch' :model='queryForm' ref='form' label-width='80px' :inline='true' size='small'
                 class='query-form' @submit.native.prevent>
            <el-form-item label='酒店名称'>
                <el-input style="width: 200px" v-model='queryForm.hotelName'></el-input>
            </el-form-item>
            <el-form-item label='省'>
                <el-select
                    placeholder='请选择省'
                    @change="clearSubitem('province')"
                    clearable
                    style='width: 200px'
                    size='small'
                    v-model='queryForm.provinceId'
                >
                    <el-option
                        v-for='(item,index) in provinceArry'
                        :key='index'
                        :label='item.areaName'
                        :value='item.id'
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label='市'>
                <el-select
                    placeholder='请选择市'
                    @change="clearSubitem('city')"
                    clearable
                    style='width: 200px'
                    size='small'
                    v-model='queryForm.cityId'
                >
                    <el-option
                        v-for='(item,index) in cityArry'
                        :key='index'
                        :label='item.areaName'
                        :value='item.id'
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label='区'>
                <el-select
                    placeholder='请选择区'
                    clearable
                    style='width: 200px'
                    size='small'
                    v-model='queryForm.areaId'
                >
                    <el-option
                        v-for='(item,index) in areaArry'
                        :key='index'
                        :label='item.areaName'
                        :value='item.id'
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label='酒店标签'>
                <el-input style="width: 200px" v-model='queryForm.hotelTag'></el-input>
            </el-form-item>
            <el-form-item label='酒店管理'>
                <GridSelectU
                    style="width: 200px"
                    title="选择用户"
                    labelName="userName"
                    labelValue="id"
                    :value="queryForm.userId"
                    :limit="1"
                    size="small"
                    placeholder="请选择用户"
                    @getValue="getUserValueQueryForm"
                    :columns="USER_code"
                    :searchs="USER_search"
                    dataListUrl="/mpp/user/findList"
                    entityBeanName="mppUser"
                    queryEntityUrl="/mpp/user/get"
                >
                </GridSelectU>
            </el-form-item>
            <el-form-item label='核审状态'>
                <el-select
                    v-model="queryForm.orderStatus"
                    size="small"
                    clearable
                    style="width: 200px"
                >
                    <el-option
                        v-for="(item,index) in hotelAuditStatusEnumList"
                        :key="index"
                        :label="item.value"
                        :value="item.key"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size='small' type='primary' icon='el-icon-search' @click='getMallHotelList'>查询</el-button>
                <el-button size='small' icon='el-icon-refresh' @click='resetDialog'>重置</el-button>
            </el-form-item>
        </el-form>
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'>
                    <!--        <el-button-->
                    <!--          type="primary"-->
                    <!--          size="small"-->
                    <!--          icon="el-icon-plus"-->
                    <!--          @click="addMallHotel"-->
                    <!--        >新建</el-button>-->
                    <el-button
                        type='warning'
                        plain
                        size='small'
                        icon='el-icon-edit'
                        :disabled='multipleSelection.length != 1'
                        @click='editMallHotel(null)'
                    >修改
                    </el-button>
                    <el-button
                        type='danger'
                        plain
                        size='small'
                        icon='el-icon-delete'
                        :disabled='multipleSelection.length <= 0'
                        @click='deleteMallHotel(null)'
                    >删除
                    </el-button>
                </div>

                <div class='icon-group'>
                    <el-upload v-if='this.isImportDate'
                               class='upload-demo'
                               action='#'
                               :http-request='upload'
                               :show-file-list='true'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title='搜索'
                        class='icon-box'
                        @click='search'
                    >
          <Icon color='#606266'>
            <Search />
          </Icon>
        </span>
                    <!--        <span-->
                    <!--          title="下载模板"-->
                    <!--          class="icon-box"-->
                    <!--          @click="importTemplate"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowDown />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          class="icon-box"-->
                    <!--          title="导入数据"-->
                    <!--          @click="isImport"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowExportUp24Regular />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          title="导出数据"-->
                    <!--          class="icon-box"-->
                    <!--          @click="exportMallHotelList"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowDownload24Regular />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <span
                        class='icon-box'
                        @click='refreshMallHotelList'
                    >
          <Icon color='#606266'>
            <Refresh />
          </Icon>
        </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data='mallHotelList'
                row-key='id'
                border
                height='100%'
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change='handleSelectionChange'
                size='small'
            >
                <el-table-column
                    align='center'
                    type='selection'
                    width='60'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='hotelName'
                    label='酒店名称'
                    width='280'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='hotelLogo'
                    label='酒店logo'
                    width='180'
                >
                    <template slot-scope='scope'>
                        <el-image
                            @click='updateSrcList(scope.row.hotelLogo)'
                            style='width: 30px; height: 30px'
                            :src='scope.row.hotelLogo'
                            :preview-src-list='srcList'
                        ></el-image>
                    </template>
                </el-table-column>
                <!--        <el-table-column-->
                <!--            :show-overflow-tooltip="true"-->
                <!--            align="center"-->
                <!--            prop="hotelBrand"-->
                <!--            label="酒店banner"-->
                <!--            width="180"-->
                <!--        >-->
                <!--        </el-table-column>-->
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='brandId'
                    label='品牌'
                    width='180'
                >
                    <template slot-scope='scope'>
                        <div>{{ computeCategory(scope.row.brandId) }}</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="hotelAddress" label="地址" width="300">
                    <template slot-scope="scope">
                        <div v-if='scope.row.hotelAddress'>
                        <div style="text-align: left;">区域:{{ scope.row.province.areaName }}{{ scope.row.city.areaName }}{{ scope.row.area.areaName }}</div>
                        <div style="text-align: left;overflow:hidden;text-overflow: ellipsis;">详细地址:{{ scope.row.hotelAddress }}</div>
                        </div>

                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <!-- <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='provinceId'
                    label='省'
                    width='180'
                >
                    <template slot-scope='scope'>
                        <div>{{ scope.row.province.areaName }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='cityId'
                    label='市'
                    width='180'
                >
                    <template slot-scope='scope'>
                        <div>{{ scope.row.city.areaName }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='areaId'
                    label='区'
                    width='180'
                >
                    <template slot-scope='scope'>
                        <div>{{ scope.row.area.areaName }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='hotelAddress'
                    label='详细地址'
                    width='180'
                ></el-table-column> -->
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='hotelPosition'
                    label='定位'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='longitude'
                    label='经度'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='latitude'
                    label='纬度'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='hotelTag'
                    label='标签'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='starNumber'
                    label='综合评分'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='commentNumber'
                    label='总评论数'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='isSelected'
                    label='是否精选'
                    width='180'
                >
                    <template slot-scope='scope'>
                        <div>{{ computeYesNo(scope.row.isSelected) }}</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="contactPerson" label="联系人" width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.contactPerson">
                            <div style="text-align: left">联系姓名:{{ scope.row.contactPerson }}</div>
                            <div style="text-align: left">联系电话:{{ scope.row.contactPhone }}</div>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <!-- <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='contactPerson'
                    label='联系人'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='contactPhone'
                    label='联系电话'
                    width='180'
                ></el-table-column> -->
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='paymentCode'
                    label='收款码'
                    width='180'
                >
                    <template slot-scope='scope'>
                        <el-image
                            @click='updateSrcList(scope.row.paymentCode)'
                            style='width: 30px; height: 30px'
                            :src='scope.row.paymentCode'
                            :preview-src-list='srcList'
                        ></el-image>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='userId'
                    label='店铺管理'
                    width='180'
                >
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='canCancelTime'
                    label='可取消时间'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='checkoutTime'
                    label='离店时间'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='minPrice'
                    label='最低价格'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='maxPrice'
                    label='最高价格'
                    width='180'
                ></el-table-column>
                <el-table-column
                    fixed='right'
                    align='center'
                    label='操作'
                    width='300'
                >
                    <template slot-scope='scop'>
                        <div class='operation'>
                            <div @click='checkMallHotel(scop.row.id)'>
                                <Icon size='16'>
                                    <Eye24Regular />
                                </Icon>
                                <span class='operation-label'>查看</span>
                            </div>
                            <div @click='editMallHotel(scop.row.id)'>
                                <Icon size='16'>
                                    <Edit24Regular />
                                </Icon>
                                <span class='operation-label'>修改</span>
                            </div>
                            <div @click='deleteMallHotel(scop.row.id)'>
                                <Icon size='16' style='color: red'>
                                    <Delete24Regular />
                                </Icon>
                                <span class='operation-label' style='color: red'>删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='sizeChange'
                    @current-change='currentChange'
                    :current-page.sync='currentPage'
                    :page-sizes='[10, 20, 50, 100]'
                    :page-size='pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    :total='totalNum'
                    background
                    :pager-count='7'
                >
                </el-pagination>
            </div>
            <hotelEdit
                :showDialog="showDialog"
                :mallHotel="mallHotel"
                :mallHotelState="mallHotelState"
                :areaTreeDate="areaTreeDate"
                @closeDialog="closeDialog"
                @submitForm="submitForm"
            ></hotelEdit>
        </div>
    </div>
</template>

<script>
import GridSelectU from '@/components/gridselect';
import Tag from '@/components/tag/tag.vue';
import hotelEdit from '@/components/hotel/hotelEdit.vue';
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import { USER, USER_SEARCH } from "@/utils/constant"
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        hotelEdit,
        Tag,
        GridSelectU
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetMallHotelList();
                this.getMallHotelList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetMallHotelList();
                this.getMallHotelList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            USER_code: USER,
            USER_search: USER_SEARCH,
            hotelAuditStatusEnumList: [],
            areaTreeDate: [],
            srcList: [''],
            brandList: [],

            queryForm: {
                hotelName: '', //酒店名称
                hotelLogo: '', //酒店logo
                hotelBanner: '', //酒店banner
                brandId: '', //品牌ID
                provinceId: '', //省
                cityId: '', //市
                areaId: '', //区
                hotelAddress: '', //详细地址
                hotelPosition: '', //定位
                longitude: '', //经度
                latitude: '', //纬度
                hotelTag: '', //标签
                starNumber: '', //综合评分
                commentNumber: '', //总评论数
                isSelected: '', //是否精选
                contactPerson: '', //联系人
                contactPhone: '', //联系电话
                remarks: '', //备注
                paymentCode: '', //收款码
                userId: '', //店铺管理
                status: '', //核审状态
                refuseReason: '', //拒绝原因
                canCancelTime: '', //可取消时间
                checkoutTime: '', //结账时间
                minPrice: '', //最低价格
                maxPrice: '' //最高价格
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            mallHotelState: 'add',

            multipleSelection: [],
            mallHotelList: [],
            mallHotel: {
                hotelName: '', //酒店名称
                hotelLogo: '', //酒店logo
                hotelBanner: '', //酒店banner
                brandId: '', //品牌ID
                provinceId: '', //省
                cityId: '', //市
                areaId: '', //区
                hotelAddress: '', //详细地址
                hotelPosition: '', //定位
                longitude: '', //经度
                latitude: '', //纬度
                hotelTag: '', //标签
                starNumber: '', //综合评分
                commentNumber: '', //总评论数
                isSelected: '', //是否精选
                contactPerson: '', //联系人
                contactPhone: '', //联系电话
                remarks: '', //备注
                paymentCode: '', //收款码
                userId: '', //店铺管理
                status: '', //核审状态
                refuseReason: '', //拒绝原因
                canCancelTime: '', //可取消时间
                checkoutTime: '', //结账时间
                minPrice: '', //最低价格
                maxPrice: '' //最高价格
            },
            btnLoading: false,
        };
    },
    created() {
        this.getTreeData();
        this.getYesNoEnum();
        this.getMallHotelBrandCategory();
        this.getMallHotelList();
        this.getAuditStatusEnum();
    },
    computed: {
        provinceArry() {
            return this.areaTreeDate;
        },
        cityArry() {
            if(!this.provinceArry){
                return []
            } else {
                for (let i = 0; i < this.provinceArry.length; i++) {
                    if (this.provinceArry[i].id === this.queryForm.provinceId) {
                        return this.provinceArry[i].children;
                    } else if (this.queryForm.provinceId === '') {
                        return [];
                    }
                }
            }
        },
        areaArry() {
            if(!this.cityArry){
                return []
            } else {
                for (let i = 0; i < this.cityArry.length; i++) {
                    if (this.cityArry[i].id === this.queryForm.cityId) {
                        return this.cityArry[i].children;
                    }
                }
            }
        }
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        resetMallHotelList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.mallHotelList = [];
        },
        resetDialog() {
            this.mallHotelState = 'add';
            this.showDialog = false;
            this.queryForm = {
                hotelName: '', //酒店名称
                hotelLogo: '', //酒店logo
                hotelBanner: '', //酒店banner
                brandId: '', //品牌ID
                provinceId: '', //省
                cityId: '', //市
                areaId: '', //区
                hotelAddress: '', //详细地址
                hotelPosition: '', //定位
                longitude: '', //经度
                latitude: '', //纬度
                hotelTag: '', //标签
                starNumber: '', //综合评分
                commentNumber: '', //总评论数
                isSelected: '', //是否精选
                contactPerson: '', //联系人
                contactPhone: '', //联系电话
                remarks: '', //备注
                paymentCode: '', //收款码
                userId: '', //店铺管理
                status: '', //核审状态
                refuseReason: '', //拒绝原因
                canCancelTime: '', //可取消时间
                checkoutTime: '', //结账时间
                minPrice: '', //最低价格
                maxPrice: '' //最高价格
            };
            this.getMallHotelList();
        },
        closeDialog() {
            this.showDialog = false;
            this.mallHotel = {
                hotelName: '', //酒店名称
                hotelLogo: '', //酒店logo
                hotelBanner: '', //酒店banner
                brandId: '', //品牌ID
                provinceId: '', //省
                cityId: '', //市
                areaId: '', //区
                hotelAddress: '', //详细地址
                hotelPosition: '', //定位
                longitude: '', //经度
                latitude: '', //纬度
                hotelTag: '', //标签
                starNumber: '', //综合评分
                commentNumber: '', //总评论数
                isSelected: '', //是否精选
                contactPerson: '', //联系人
                contactPhone: '', //联系电话
                remarks: '', //备注
                paymentCode: '', //收款码
                userId: '', //店铺管理
                status: '', //核审状态
                refuseReason: '', //拒绝原因
                canCancelTime: '', //可取消时间
                checkoutTime: '', //结账时间
                minPrice: '', //最低价格
                maxPrice: '' //最高价格
            };
        },
        submitForm() {
            console.log('submit');
            delete this.mallHotel.province
            delete this.mallHotel.city
            delete this.mallHotel.area
            delete this.mallHotel.brand

            console.log('this.mallHotel',this.mallHotel)
            post(`/mall/hotel/edit`, { ...this.mallHotel }).then((res) => {
                if (res.success && res.code == 200) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                    this.resetMallHotelList();
                    this.resetDialog();
                    this.getMallHotelList();
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        addMallHotel() {
            this.showDialog = true;
            this.mallHotelState = 'add';
        },
        checkMallHotel(mallHotelId) {
            console.log(mallHotelId);
            this.currentMallHotelId = mallHotelId;

            this.getMallHotelById();
            this.showDialog = true;
            this.mallHotelState = 'check';
        },
        editMallHotel(mallHotelId) {
            console.log('mallHotel', mallHotelId);
            if (mallHotelId) {
                this.currentMallHotelId = mallHotelId;
                this.getMallHotelById();
            } else {
                this.mallHotel = { ...this.mallHotel, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.mallHotelState = 'edit';
        },
        deleteMallHotel(mallHotelId) {
            let ids = '';
            if (mallHotelId) {
                ids = mallHotelId;
            } else {
                ids = this.multipleSelection.map((mallHotel) => mallHotel.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/mall/hotel/delete`, { ids }).then((res) => {
                        if (res.success && res.code == 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetMallHotelList();
                            this.getMallHotelList();
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshMallHotelList() {
            this.resetMallHotelList();
            this.getMallHotelList();
        },
        getMallHotelList(query = {}) {
            this.loading = true;
            get(`/mall/hotel/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.mallHotelList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getMallHotelById() {
            get(`/mall/hotel/get`, { id: this.currentMallHotelId }).then((res) => {
                if (res.success) {
                    this.mallHotel = { ...this.mallHotel, ...res.mallHotel };
                }
            });
        },
        /**
         * 导出信息
         */
        exportMallHotelList() {
            //this.btnLoading = true;
            exprotExcel(`/mall/hotel/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/mall/hotel/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/mall/hotel/importData`, formData);
            this.refreshMallHotelList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getMallHotelList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getMallHotelList();
        },
        updateSrcList(src) {
            this.srcList[0] = src;
        },

        // 获取全部的品牌类型
        getMallHotelBrandCategory() {
            get('/mall/hotelbrand/findAll').then((res) => {
                if (res.success) {
                    this.brandList = res.list;
                }
            });
        },

        // 获取yes_no枚举
        getYesNoEnum() {
            get('/mpp/utils/getEnum', {
                enumType: 'yes_no'
            }).then((res) => {
                if (res.success) {
                    this.yesNoEnumList = res.enumList;
                }
            });
        },

        // 计算是否
        computeYesNo(key) {
            for (let i = 0; i < this.yesNoEnumList.length; i++) {
                if (this.yesNoEnumList[i].key == key) {
                    return this.yesNoEnumList[i].value;
                }
            }
        },

        // 计算品牌类型
        computeCategory(id) {
            for (let i = 0; i < this.brandList.length; i++) {
                if (this.brandList[i].id == id) {
                    return this.brandList[i].brandName;
                }
            }
        },

        // 獲取地理編碼
        getTreeData(){
            get('/mpp/area/treeData').then((res)=>{
                if(res.success){
                    this.areaTreeDate = res.treeData[0].children
                }
            })
        },

        // 省市区清除器
        clearSubitem(id) {
            if (id == 'province') {
                this.queryForm.cityId = '';
                this.queryForm.areaId = '';
            } else if (id == 'city') {
                this.queryForm.areaId = '';
            }
        },

        getUserValueQueryForm(value){
            this.queryForm.userId = value
        },

        getAuditStatusEnum(){
            get('/mpp/utils/getEnum',{ enumType:'audit_status' }).then((res)=>{
                if(res.success){
                    this.hotelAuditStatusEnumList = res.enumList
                }
            })
        },
    }
};
</script>

<style lang='scss' scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>